<style scoped>
    .expand-row{
        margin-bottom: 1px;
    }
</style>
<template>
    <div>
        <ProjectMember ref="ProjectMember" :projectId="projectId" :node="node"></ProjectMember>
        <Row class="expand-row">
            <Col span="22">
              <tables border search-place="bottom" :stripe="true" :show-header="false" :loading="tableLoading" v-model="tableData" :columns="columns"/>
                <div style="margin: 10px 0; overflow: hidden;">
                <div style="float: left;">
                当前显示 {{ tableData.length }} 条记录，总共 {{ count }} 条记录
                </div>
                <div style="float: right;">
                <page :total="count" :current="page" :page-size="size" @on-change="getTableData"></page>
                </div>
            </div>
            </Col>
        </Row>
    </div>
</template>
<script>
import Tables from '_c/tables'
import { getGroupProjects } from '@/api/tools/gitlab'
import ProjectMember from './ProjectMember'

export default {
  name: 'type-expand',
  components: {
    Tables,
    ProjectMember
  },
  props: {
    row: Object
  },
  data () {
    return {
      node: Object.keys(this.row).length > 0 ? this.row.node : '',
      projectId: null,
      count: 0,
      size: 10,
      page: 1,
      tableLoading: false,
      columns: [
        {
          title: '名称',
          key: 'name',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.projectId = params.row.id
                    this.$refs.ProjectMember.openModal()
                  }
                }
              }, '配置项目成员')
            ])
          }
        }
      ],
      tableData: []
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.getTableData()
    },
    // 获取表格数据
    getTableData (value = 1) {
      this.tableLoading = true
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page,
        'group_id': this.row.id,
        'node': this.node
      }
      getGroupProjects(params).then(res => {
        console.log(res.data.results)
        this.tableData = res.data.results
        this.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
      })
    }
  }
}
</script>
